package modysy

import modysy.datastructures.Vector2
import modysy.view.Render
import org.scalajs.dom
import org.scalajs.dom.KeyboardEvent

import scala.collection.mutable

class InputHandler(
    gameController: GameController,
    renderer: Render
) {
  val keysDown: mutable.HashMap[Int, Boolean] = mutable.HashMap[Int, Boolean]()

  var mouseCanvasPos: Option[Vector2] = None

  val onClickEvents: mutable.ArrayBuffer[(Vector2, GameController) => Unit] =
    mutable.ArrayBuffer.empty[(Vector2, GameController) => Unit]
  val onMoveEvents: mutable.ArrayBuffer[(Vector2, GameController) => Unit] =
    mutable.ArrayBuffer.empty[(Vector2, GameController) => Unit]
  val onPressEvents
    : mutable.ArrayBuffer[(dom.KeyboardEvent, GameController) => Unit] =
    mutable.ArrayBuffer.empty[(dom.KeyboardEvent, GameController) => Unit]
  val onPressMouseEvents: mutable.ArrayBuffer[
    (dom.KeyboardEvent, Option[Vector2], GameController) => Unit
  ] =
    mutable.ArrayBuffer
      .empty[(dom.KeyboardEvent, Option[Vector2], GameController) => Unit]

  var keysEvent: mutable.HashMap[Int, Boolean] =
    mutable.HashMap[Int, Boolean]()
  var scrollEvent: Double = 0.0
  var mouseIsDown: Boolean = false

  private val onTouchStartEvents: mutable.ArrayBuffer[dom.TouchEvent => Unit] =
    mutable.ArrayBuffer.empty[dom.TouchEvent => Unit]

  private val onTouchMoveEvents: mutable.ArrayBuffer[dom.TouchEvent => Unit] =
    mutable.ArrayBuffer.empty[dom.TouchEvent => Unit]

  private val onTouchEndEvents: mutable.ArrayBuffer[dom.TouchEvent => Unit] =
    mutable.ArrayBuffer.empty[dom.TouchEvent => Unit]

  private val onTouchCancelEvents: mutable.ArrayBuffer[dom.TouchEvent => Unit] =
    mutable.ArrayBuffer.empty[dom.TouchEvent => Unit]

  /* TODO so ugly, so sad
   *
   * this is just by the AbstractButton handling the touch interactions
   * the AbstractButton requires canvas positions, but the TouchEvent passed
   * to the button only provides screen positions
   *
   * usually the GameController can convert the positions, but the
   * AbstractButton uses the event handler directly
   */
  def screenToCanvasWorkAround: Vector2 => Vector2 = renderer.screenToCanvas

  dom.window.addEventListener("keydown", (e: dom.KeyboardEvent) => {
    keysDown += e.keyCode -> true
  }, false)

  dom.window.addEventListener("keyup", (e: dom.KeyboardEvent) => {
    if (keysEvent.contains(e.keyCode)) keysEvent -= e.keyCode
    else keysEvent += e.keyCode -> true
    keysDown -= e.keyCode
  }, false)

  dom.window.onmousemove = (e: dom.MouseEvent) => {
    mouseCanvasPos = Some(renderer.screenToCanvas(e.clientX, e.clientY))

    for (x <- onMoveEvents) {
      x(
        renderer.screenToCanvas(e.clientX, e.clientY),
        gameController
      )
    }
  }

  dom.window.onkeypress = (e: dom.KeyboardEvent) => {
    for (x <- onPressEvents) {
      x(e, gameController)
    }

    for (x <- onPressMouseEvents) {
      x(e, mouseCanvasPos, gameController)
    }

  }

  dom.window.onmousedown = (e: dom.MouseEvent) => {
    mouseIsDown = true
  }

  dom.window.onmouseup = (_: dom.MouseEvent) => {
    mouseIsDown = false
  }

  dom.window.onclick = (e: dom.MouseEvent) => {
    for (x <- onClickEvents) {
      x(
        renderer.screenToCanvas(e.clientX, e.clientY),
        gameController
      )
    }
  }

  dom.ext.TouchEvents.WindowToTouchEvents(dom.window).ontouchstart =
    (e: dom.TouchEvent) => {
      if (renderer.canvas == e.target) {
        e.preventDefault()
        mouseCanvasPos = None
        onTouchStartEvents.foreach(_(e))
      }
    }

  dom.ext.TouchEvents.WindowToTouchEvents(dom.window).ontouchmove =
    (e: dom.TouchEvent) => {
      if (renderer.canvas == e.target) {
        e.preventDefault()
        mouseCanvasPos = None
        onTouchMoveEvents.foreach(_(e))
      }
    }

  dom.ext.TouchEvents.WindowToTouchEvents(dom.window).ontouchend =
    (e: dom.TouchEvent) => {
      if (renderer.canvas == e.target) {
        e.preventDefault()
        mouseCanvasPos = None
        onTouchEndEvents.foreach(_(e))
      }
    }

  dom.ext.TouchEvents.WindowToTouchEvents(dom.window).ontouchcancel =
    (e: dom.TouchEvent) => {
      if (renderer.canvas == e.target) {
        e.preventDefault()
        mouseCanvasPos = None
        onTouchCancelEvents.foreach(_(e))
      }
    }

  dom.window.addEventListener("wheel", (e: dom.WheelEvent) => {
    this.scrollEvent += e.deltaY
    e.preventDefault()
  }, false)

  def bindOnClickEvents(onClick: (Vector2, GameController) => Unit): Unit = {
    onClickEvents += onClick
  }

  def bindOnMoveEvents(onMove: (Vector2, GameController) => Unit): Unit = {
    onMoveEvents += onMove
  }

  def bindOnPressEvents(
      onPress: (dom.KeyboardEvent, GameController) => Unit
  ): Unit = {
    onPressEvents += onPress
  }

  def bindOnPressAndMouseEvents(
      function: (KeyboardEvent, Option[Vector2], GameController) => Unit
  ): Unit = {
    onPressMouseEvents += function
  }

  def bindOnTouchStartEvents(onTouchStart: dom.TouchEvent => Unit): Unit = {
    onTouchStartEvents += onTouchStart
  }

  def bindOnTouchMoveEvents(onTouchMove: dom.TouchEvent => Unit): Unit = {
    onTouchMoveEvents += onTouchMove
  }

  def bindOnTouchEndEvents(onTouchEnd: dom.TouchEvent => Unit): Unit = {
    onTouchEndEvents += onTouchEnd
  }

  def bindOnTouchCancelEvents(onTouchCancel: dom.TouchEvent => Unit): Unit = {
    onTouchCancelEvents += onTouchCancel
  }

  def activeKeyEvent(key: Int): Boolean = {
    return keysEvent.contains(key)
  }

  def clearKeyEvents(key: Int = -1): Unit = {
    if (key > 0) {
      keysEvent -= key
    } else {
      keysEvent = mutable.HashMap[Int, Boolean]()
    }
  }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/2d4fb5cd/0/mtv-pr-2018/modysy-product/src/main/scala/modysy/InputHandler.scala